export default {
  ProjectNumber: 'Project Number',
  ClientName: 'Client Name',
  LinkMan: 'Link Man',
  ContactNumber: 'ContactNumber',
  ContactAddress: 'Contact Address',
  BillingAddress: 'Billing Address',
  CustomerAccount: 'Customer Account',
  SearchPlaceholder: 'Search keywords',
  businessType: 'Business Type',
  businessStatus: 'Business Status',
  bandwidth: 'bandwidth',
  circuitNumber: 'circuit Number',
  AccelerateDemand: 'Accelerate Demand',
  StartingTime: 'Starting Time',
  LeaseStopTime: 'Lease Stop Time',
  CustomerDetails: 'Customer Details',
}
